import React, { useEffect, useState } from "react";
import PageTitle from "../../Components/PageTitle";
import {
  Box,
  Paper,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Breadcrumbs,
  Link as MUILink,
} from "@mui/material";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";
import { message, Modal } from "antd";
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import axios from "../../axiosInstance";

const Exams = () => {
  const { user } = useSelector((state) => state.user);
  const [exams, setExams] = useState([]);
  const [filteredExams, setFilteredExams] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  // Get All Exam Data
  const getAllExams = async () => {
    try {
      const response = await axios.get(`/api/v1/exam/all`);
      console.log(response, "response from get all exams");
      //  setExams(publicExam);
      if (response?.data?.success === true) {
        // const publicExam = response?.data?.data.filter(exam=> exam.publicExam === "no");
        setExams(response?.data?.data);
        setFilteredExams(response?.data?.data);
      }
       else {
        message.error(response?.data?.message);
      }
    } catch (error) {
      message.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    getAllExams();
  }, []);

  // Delete Exam
  const { confirm } = Modal;
  // const deleteExam = async (e, id) => {
  //   confirm({
  //     title: "Are you sure you want to delete this Exam?",
  //     content:
  //       "This action will permanently delete the exam. Are you sure you want to continue?",
  //     okText: "Yes, Delete",
  //     cancelText: "No, Cancel",
  //     onOk: async () => {
  //       try {
  //         const { data } = await axios.delete(
  //           `/api/v1/exam/${id}`,
  //         );
  //         if (data.success === true) {
  //           message.success(data.message);
  //           getAllExams();
  //         } else {
  //           message.error(data.message);
  //         }
  //       } catch (error) {
  //         message.error(
  //           error?.response?.data?.message || "Failed to delete exam."
  //         );
  //       }
  //     },
  //     onCancel() {
  //       console.log("Delete action canceled.");
  //     },
  //   });
  // };

 const localExamId = localStorage.getItem("id");
console.log(localExamId, "localExamId from exams page");
  const deleteExam = async (e, id) => {
  confirm({
    title: "Are you sure you want to delete this Exam?",
    content:
      "This action will permanently delete the exam. Are you sure you want to continue?",
    okText: "Yes, Delete",
    cancelText: "No, Cancel",
    onOk: async () => {
      try {
        const { data } = await axios.delete(`/api/v1/exam/${id}`);

        if (data.success) {
          
const localExamId = JSON.parse(localStorage.getItem("id"));
          if (localExamId === id) {
            localStorage.removeItem("id");
          }

          message.success(data.message);
          getAllExams();
        } else {
          message.error(data.message);
        }
      } catch (error) {
        message.error(
          error?.response?.data?.message || "Failed to delete exam."
        );
      }
    },
  });
};
  // Filter exams based on search query and selected category
  useEffect(() => {
    let filtered = exams;

    if (searchQuery) {
      filtered = filtered.filter((exam) =>
        exam.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (selectedCategory) {
      filtered = filtered.filter((exam) => exam.subject === selectedCategory);
    }

    setFilteredExams(filtered);
  }, [searchQuery, selectedCategory, exams]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      width: 10,
      sortable: false,
    },
    {
      field: "Actions",
      width: 90,
      renderCell: (value) => (
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <IconButton
            aria-label="delete"
            onClick={(e) => deleteExam(e, value?.row?._id)}
          >
            <DeleteIcon sx={{ color: "red" }} />
          </IconButton>
          <Link to={`/admin/edit/exam/${value?.row?._id}`}>
            <IconButton aria-label="edit">
              <EditIcon sx={{ color: "#1976d2" }} />
            </IconButton>
          </Link>
        </Box>
      ),
    },
    {
      field: "name",
      headerName: "Exam Name",
      width: '200',
      editable: true,
    },
    {
      field: "subject",
      headerName: "Subject",
      width: 130,
      editable: true,
    },
    // {
    //   field: "examSet",
    //   headerName: "Exam Type",
    //   width: 110,
    //   editable: true,
    // },
    {
      field: "questions",
      headerName: "Total Questions",
      width: 120,
      editable: true,
      renderCell: (row) => row?.row?.questions?.length,
    },
    {
      field: "duration",
      headerName: "Duration",
      width: 120,
      editable: true,
    },
    {
      field: "totalMarks",
      headerName: "Total Marks",
      width: 120,
      editable: true,
    },
    {
      field: "passingMarks",
      headerName: "Passing Marks",
      width: 120,
      editable: true,
    },
    {
      field: "negativeMarking",
      headerName: "Negative Marks",
      width: 110,
      editable: true,
    },
    {
      field: "startDate",
      headerName: "Start Date",
      width: 120,
      editable: true,
    },
    {
      field: "endDate",
      headerName: "End Date",
      width: 120,
      editable: true,
    },
  ];

  return (
    <div> 
      <PageTitle  
      title="MCQ Exams List - Manage All Exams | Shree Mangalam School" 
      description="View and manage the complete list of all exams from the admin & institute dashboard. Add, edit, delete, and monitor test performance with detailed insights."
      keywords="test series, Shree Mangalam School online exam, admin exam list, manage exams, test series management, online exam dashboard, admin & institute dashboard exam control, exam settings"
      />
      <Box>
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          sx={{
            mb: 3,
            fontFamily: "Poppins, sans-serif",
            color: "#2C3E50",
            letterSpacing: "2.5px",
            lineHeight: 1.8,
          }}
        >
          All Exams
        </Typography>
        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
            mb: 5,
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          }}
        >
          <MUILink
            component={Link}
            to="/dashboard"
            sx={{ color: "inherit", textDecoration: "none" }}
          >
            Dashboard
          </MUILink>
          <Typography sx={{ color: "primary.main" }}>Exams</Typography>
        </Breadcrumbs>
        <Box
          style={{
            width: "auto",
            overflowY: "hidden",
            overflowX: "scroll",
          }}
        >
          <Box
            sx={{
              pb: 2,
              display: "flex",
              width: "auto",
              justifyContent: "left",
            }}
          >
            <Link style={{ textDecoration: "none" }} to="/admin/add/exam">
              <Button
                variant="contained"
                color="success"
                startIcon={<AddIcon />}
                className="courses_desc"
                sx={{
                  borderRadius: "5px",
                  textTransform: "none",
                  fontFamily: "Poppins, sans-serif",
                  letterSpacing: ".1rem",
                  color: "white",
                }}
              >
                Create Exam
              </Button>
            </Link>
          </Box>

          {/* Search Input */}
          <Box sx={{ pb: 2, mt: 2 }}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search by Exam Name"
              value={searchQuery}
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <IconButton>
                    <SearchIcon sx={{ color: "#1976d2" }} />
                  </IconButton>
                ),
              }}
              sx={{
                mb: 3,
                bgcolor: "white",
                borderRadius: "20px",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "none",
                  },
                  "&:hover fieldset": {
                    border: "none",
                  },
                  "&.Mui-focused fieldset": {
                    border: "none",
                  },
                },
              }}
            />
          </Box>
          <Box sx={{ pb: 2 }}>
            <FormControl
              fullWidth
              sx={{
                mb: 3,
                bgcolor: "white",
                borderRadius: "20px",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "none",
                  },
                  "&:hover fieldset": {
                    border: "none",
                  },
                  "&.Mui-focused fieldset": {
                    border: "none",
                  },
                },
              }}
            >
              <InputLabel>Filter by Category</InputLabel>
              <Select
                value={selectedCategory}
                onChange={handleCategoryChange}
                placeholder="Filter by Subject"
              >
                <MenuItem value="">
                  <em>All</em>  
                </MenuItem>
                {Array.from(new Set(exams.map((exam) => exam.subject))).map(
                  (subject) => (
                    <MenuItem key={subject} value={subject}>
                      {subject}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Box>
          <Paper sx={{ bgcolor: "white" }}>
            <Box sx={{ height: 500, width: "100%" }}>
              <DataGrid
                getRowId={(row) => row?._id}
                sx={{
                  "& .MuiTablePagination-displayedRows": {
                    color: "black",
                  },
                  color: "black",
                  [`& .${gridClasses?.row}`]: {
                    bgcolor: "white",
                  },
                  //  "& .MuiDataGrid-columnHeaders": {
                  //    backgroundColor: "rgb(25, 118, 210)",
                  //    },
                  // Style for header cells
                  "& .MuiDataGrid-columnHeaders": {
                    // backgroundColor: "rgb(25, 118, 210) !important",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    color: "black",
                    fontWeight: "bold",
                    // fontSize: "13px",
                  },
                  "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
                    color: "#FFF",
                  },
                  "& .MuiDataGrid-iconButtonContainer .MuiSvgIcon-root": {
                    color: "white",
                  },
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                }}
                rows={filteredExams.map((row, index) => ({
                  ...row,
                  rowNumber: index + 1,
                }))}
                columns={columns}
                pageSize={3}
                rowsPerPageOptions={[3]}
              />
            </Box>
          </Paper>
        </Box>
      </Box>
    </div>
  );
};

export default Exams;
